import { Injectable } from '@angular/core';
import {ContentAssignmentDetails, ContentAssignmentEmployeeFilter} from "../_models/generatedModels";
import {SelectedContentItem} from "../_models/models";

@Injectable({ providedIn: 'root' })
export class ContentAssignmentWizardService {
  private state = {
    selectedContent: null as SelectedContentItem[] | null,
    employeeSelection: null as {
      filter: ContentAssignmentEmployeeFilter;
      selectedCount?: number;
      currentPage?: number;
      pageSize?: number;
    } | null,
    assignmentDetails: null as ContentAssignmentDetails | null
  };

  constructor() {}

  // Content step methods
  setSelectedContent(content: SelectedContentItem[] | null) {
    this.state.selectedContent = content;
  }

  getSelectedContent() {
    return this.state.selectedContent;
  }

  // Employee step methods
  setEmployeeSelection(filter: ContentAssignmentEmployeeFilter, selectedCount?: number, currentPage?: number, pageSize?: number) {
    this.state.employeeSelection = { filter, selectedCount, currentPage, pageSize };
  }

  getEmployeeSelection() {
    return this.state.employeeSelection;
  }

  // Details step methods
  setAssignmentDetails(details: ContentAssignmentDetails) {
    this.state.assignmentDetails = details;
  }

  getAssignmentDetails() {
    return this.state.assignmentDetails;
  }

  // Get full state
  getState() {
    return { ...this.state };
  }

  // Validation methods
  canProceedToEmployees(): boolean {
    return this.state.selectedContent?.length > 0;
  }

  canProceedToDetails(): boolean {
    return this.state.employeeSelection?.selectedCount > 0;
  }

  canProceedToAssignment(): boolean {
    return !!this.state.assignmentDetails;
  }

  // Reset wizard state
  reset() {
    this.state = {
      selectedContent: null,
      employeeSelection: null,
      assignmentDetails: null
    };
  }
}
